import loadable from "@loadable/component";

import LoadingIndicator from "../../components/LoadingIndicator";

const LodableComponent = loadable(() => import("./index"), {
  fallback: <LoadingIndicator />,
});

export default LodableComponent;
